import { config } from '@/configs/env';
import { apiFetch } from '@/lib/api-service';
import type {
  SearchQuerySuggestionsRequest,
  SearchQuerySuggestionsResponse,
  SearchSuggestionProduct,
} from '@/types';

export async function querySuggestions(
  payload: SearchQuerySuggestionsRequest
): Promise<SearchSuggestionProduct[]> {
  const response = await apiFetch<SearchQuerySuggestionsResponse>(
    `${config.LOTUS_SEARCH_ENDPOINT}/indexes/query-suggestions/search`,
    {
      cache: 'force-cache',
      revalidate: 300,
      body: payload,
      method: 'POST',
    }
  );

  return response.data?.products ?? [];
}
